import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'next-i18next';
import { PackageIcon } from '@phosphor-icons/react';
import { useUI } from '@context/GlobalUIContext';
import SimpleButton from '_components/UI/SimpleButton';

import styles from './SoldAndShippedByTag.module.scss';

interface SoldAndShippedByTagProps {
  sellerName: string;
  classNames?: string;
}

const SoldAndShippedByTag = ({
  sellerName,
  classNames,
}: SoldAndShippedByTagProps) => {
  const { t } = useTranslation('common');
  const { openMarketplaceSellerModal } = useUI();

  return (
    <div className={cn(styles.container, classNames)}>
      <PackageIcon size={20} weight="light" className={styles.icon} />
      <SimpleButton
        className={styles.simpleButton}
        size="small"
        variant="secondary"
        onClick={() => {
          openMarketplaceSellerModal({ sellerName: sellerName });
        }}
      >
        {t('marketplacer.soldAndShippedBy', { sellerName })}
      </SimpleButton>
    </div>
  );
};
export default SoldAndShippedByTag;
